export const BrandEmblem = ({ size = 44 }) => (
  <div
    className="flex items-center justify-center rounded-xl border-2 border-[#D4AF37] bg-white shadow-lg overflow-hidden shrink-0"
    style={{ width: size, height: size }}
    data-testid="brand-emblem"
  >
    <img
      src="/brand/logo-mark.png"
      alt="Acuity Rise Education Group"
      className="w-full h-full object-contain p-[3px]"
      draggable="false"
    />
  </div>
);

export const BrandHorizontal = ({ className = "" }) => (
  <img
    src="/brand/logo-horizontal.png"
    alt="Acuity Rise Education Group"
    className={`object-contain ${className}`}
    draggable="false"
    data-testid="brand-horizontal"
  />
);
